import { MessageRecipient } from '../../models/Message';

export const convertToOfficeRecipient = (recipient: MessageRecipient) => ({
  displayName: recipient.emailAddress.name,
  emailAddress: recipient.emailAddress.address,
});
